import { render, staticRenderFns } from "./widget-component-vertical.vue?vue&type=template&id=1bd24399&scoped=true"
import script from "./widget-component-vertical.vue?vue&type=script&lang=ts"
export * from "./widget-component-vertical.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd24399",
  null
  
)

export default component.exports